import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { TaskViewType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { Title, Text } from '@yoweb/ui/components/typography';
import { deleteTask } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { ActionModalFooter, ActionModalContainer, ActionModalContent, ActionModalHeader, ActionModalError } from '@poplar/components/ActionModal';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DeleteTaskModalContent = function DeleteTaskModalContent(_ref) {
  var task = _ref.task,
      onClose = _ref.onClose,
      onTaskDeleted = _ref.onTaskDeleted;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useToast = useToast(),
      showToastMessage = _useToast.showToastMessage;

  var _useState = useState(false),
      isDeleting = _useState[0],
      setIsDeleting = _useState[1];

  var _useState2 = useState(false),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var closeModal = function closeModal() {
    setHasError(false);
    setIsDeleting(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };

  var handleDeleteTask = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var deleted;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsDeleting(true);

              if (task) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return deleteTask(task.taskId);

            case 5:
              deleted = _context.sent;

              if (!(deleted.status === ApiResponseStatus.ERROR)) {
                _context.next = 9;
                break;
              }

              setIsDeleting(false);
              return _context.abrupt("return", setHasError(true));

            case 9:
              onTaskDeleted === null || onTaskDeleted === void 0 ? void 0 : onTaskDeleted();
              closeModal();
              return _context.abrupt("return", showToastMessage({
                message: t('toasts.delete')
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDeleteTask() {
      return _ref2.apply(this, arguments);
    };
  }();

  var isDraft = (task === null || task === void 0 ? void 0 : task.taskView) === TaskViewType.TASK_VIEW_TYPE_MY_TO_DOS;
  return /*#__PURE__*/_jsxs(ActionModalContainer, {
    fullScreenMobile: true,
    minHeight: {
      _: 448,
      md: 448,
      lg: 448
    },
    children: [/*#__PURE__*/_jsx(ActionModalHeader, {}), /*#__PURE__*/_jsxs(ActionModalContent, {
      children: [/*#__PURE__*/_jsxs(Box, {
        pt: "medium1",
        display: "flex",
        flexDirection: "column",
        rowGap: "small4",
        alignItems: "center",
        "data-testid": "delete-task-modal",
        children: [/*#__PURE__*/_jsx(Title, {
          id: "delete-modal-title",
          size: "sm",
          textAlign: "center",
          as: "h3",
          "data-testid": "delete-modal-title",
          children: t(isDraft ? 'delete-draft-task-title' : 'delete-upcoming-task-title')
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          "data-testid": "delete-modal-subtitle",
          children: t('delete-changes-warning')
        })]
      }), /*#__PURE__*/_jsx(ActionModalError, {
        error: hasError,
        onErrorDismissed: function onErrorDismissed() {
          return setHasError(false);
        }
      })]
    }), /*#__PURE__*/_jsxs(ActionModalFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: handleDeleteTask,
        isLoading: isDeleting,
        "data-testid": "delete-modal-delete-button",
        children: t('actions.delete', {
          ns: 'common'
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: closeModal,
        variant: "secondary",
        "data-testid": "delete-modal-cancel-button",
        children: t('actions.cancel', {
          ns: 'common'
        })
      })]
    })]
  });
};